import React from 'react';

export type ClausesContextValue = {
  standards: Set<string>;
  clauses: Set<string>;
  registerClause: (standard: string, clause: string) => void;
};

const ClausesContext = React.createContext<ClausesContextValue | null>(null);

export function MSGClausesProvider({ children }: { children: React.ReactNode }) {
  const [standards, setStandards] = React.useState<Set<string>>(new Set());
  const [clauses, setClauses] = React.useState<Set<string>>(new Set());

  const registerClause = React.useCallback((standard: string, clause: string) => {
    setStandards((prev) => {
      const std = String(standard || '').trim();
      if (!std) return prev;
      if (prev.has(std)) return prev; // no state change
      const next = new Set(prev);
      next.add(std);
      return next;
    });
    setClauses((prev) => {
      const cl = String(clause || '').trim();
      if (!cl) return prev;
      if (prev.has(cl)) return prev; // no state change
      const next = new Set(prev);
      next.add(cl);
      return next;
    });
  }, []);

  const value = React.useMemo<ClausesContextValue>(() => ({ standards, clauses, registerClause }), [standards, clauses, registerClause]);

  return (
    <ClausesContext.Provider value={value}>
      {children}
    </ClausesContext.Provider>
  );
}

export function useMSGClauses() {
  const ctx = React.useContext(ClausesContext);
  return ctx;
}
